import api from './index';
import { authenticatedPost } from './authenticatedRequest';

/**
 * 获取支付链接
 */
export const getPaymentUrl = async ({ uid, product_id, domain = 'ai2you.org', channel, desc, query_password }) => {
  try {
    const response = await api.post('/testapi/payment/payment_ali_hk_controller/get_product_pay_url_by_channel_by_aimonkey_guest', {
      uid,
      product_id,
      domain,
      channel,
      ...(query_password !== undefined && { query_password }),
      ...(desc && { desc }),
    });
    return response;
  } catch (error) {
    console.error('获取支付链接失败:', error);
    throw error;
  }
};

/**
 * 创建 PayNow 支付
 */
export const createPayNowPayment = async ({ uid, product_id, shopperName, domain = 'ai2you.org', desc, query_password }) => {
  try {
    const response = await api.post('/testapi/payment/payment_airwallex_controller/airwallex_create_paynow', {
      uid,
      product_id,
      shopperName,
      domain,
      ...(query_password !== undefined && { query_password }),
      ...(desc && { desc }),
    });
    return response;
  } catch (error) {
    console.error('创建 PayNow 支付失败:', error);
    throw error;
  }
};

/**
 * 创建加密货币支付
 */
export const createCryptoPayment = async ({ uid, product_id, domain = 'ai2you.org', email, desc, query_password }) => {
  try {
    const response = await api.post('/testapi/payment/payment_plisio_controller/plisio_create_invoice', {
      uid,
      product_id,
      domain,
      email,
      ...(query_password !== undefined && { query_password }),
      ...(desc && { desc }),
    });
    return response;
  } catch (error) {
    console.error('创建加密货币支付失败:', error);
    throw error;
  }
};

/**
 * 检查产品是否可售
 */
export const checkProductSaleStatus = async ({ productIds }) => {
  try {
    const response = await api.post('/testapi/payment/product_controller/check_product_sale_status', {
      product_ids: productIds,
    });
    return response;
  } catch (error) {
    console.error('检查产品可售状态失败:', error);
    throw error;
  }
};

/**
 * 查询订单信息
 */
export const getOrderInfo = async (orderId) => {
  try {
    const response = await api.get(`/testapi/payment/order/${orderId}`);
    return response;
  } catch (error) {
    console.error('查询订单失败:', error);
    throw error;
  }
};

/**
 * 根据订单号查询产品信息
 */
export const getOrderProductInfo = ({ orderId, uid }) => authenticatedPost(
  '/testapi/payment/product_controller/get_order_type_by_orderid',
  { orderId: String(orderId), uid: String(uid) },
  { skipTokenValidation: true }
);

/**
 * 使用此单查询密码获取详情。密码保留空格和前导零，不记录请求内容。
 */
export const getOrderProductInfoWithPassword = ({ orderId, uid, query_password }) => (
  authenticatedPost('/testapi/payment/product_controller/get_order_type_by_orderid_with_password', {
    orderId: String(orderId),
    uid: String(uid),
    query_password: String(query_password)
  }, { skipTokenValidation: true })
);

/**
 * 获取用户历史订单
 * 后端 SQL 仅返回 order_status = 0 的订单，按当前业务约定即"已完成订单"
 * uid 可能是单个 ID、邮箱字符串，也可能是多个账号的数组，原样透传给后端
 */
export const getOrderHistory = ({ uid }, options) => authenticatedPost(
  '/testapi/payment/payment_controller/get_order_history',
  { uid },
  { ...options, skipTokenValidation: true }
);
